import { IconButton } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import Flex from "../../../../../../../components/Flex";
import Text from "../../../../../../../components/Text";
import {
  CHART_COLORS,
  CHART_DIMENSIONS,
  CHART_TYPOGRAPHY,
} from "../../../../../../../components/app/provider/patient/chart";
import { EditPencilIcon } from "../../../../../../../components/svg-icons/material-icons";
import useDisclosure from "../../../../../../../hooks/use-disclosure";
import { AddNewPatientTab } from "../../../UpsertPatientForm";
import UpsertPatientFormDrawer from "./UpsertPatientFormDrawer";

interface TitleStripV2Props {
  title: string;
  showEditButton?: boolean;
  preSelectedTab?: AddNewPatientTab;
}

const TitleStripV2 = ({
  title,
  showEditButton = true,
  preSelectedTab,
}: TitleStripV2Props) => {
  const disclosureHost = useDisclosure();
  const { patientData }: any = useOutletContext();

  return (
    <>
      <UpsertPatientFormDrawer
        disclosureHost={disclosureHost}
        patientData={patientData}
        preSelectedTab={preSelectedTab}
      />
      {/* Matches Figma 3.2.1 Patient/Profile/Demographics — Card/Row header:
          px 12, py 4, gap 10, bg slate/z-0, 30px min height, Title/T6/Medium. */}
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          minHeight: CHART_DIMENSIONS.cardHeaderHeight,
          px: "12px",
          py: "4px",
          gap: "10px",
          bgcolor: CHART_COLORS.surfaceHeader,
          borderBottom: `1px solid ${CHART_COLORS.border}`,
        }}
      >
        <Text
          sx={{
            ...CHART_TYPOGRAPHY.title6,
            fontWeight: CHART_TYPOGRAPHY.weight.medium,
            color: CHART_COLORS.textDark,
            fontFamily: CHART_TYPOGRAPHY.fontFamily,
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Text>

        {showEditButton && (
          <IconButton
            size="small"
            onClick={() => disclosureHost.open()}
            sx={{ p: "2px", flexShrink: 0 }}
          >
            {<EditPencilIcon />}
          </IconButton>
        )}
      </Flex>
    </>
  );
};

export default TitleStripV2;
